const config = {
  apibaseUrl: process.env.REACT_APP_API_BASE_URL,  // ✅ Fix here
  apibaseUrlBackend: process.env.REACT_APP_API_BASE_URLS,
};

export default config;
